import { Router } from '@angular/router';
import { MyProfileService } from './my-profile.service';
import { Component, OnInit } from '@angular/core';
import {MyProfile} from '../models/MyProfile';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule],
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
  public myProfileArr: MyProfile = {} as MyProfile;

  constructor(
    private service: MyProfileService,
    public route: Router
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      await this.service.showSpinner();
      this.myProfileArr = await lastValueFrom(this.service.getMyProfile());
    } catch (error) {
      console.error(error);
    } finally {
      await this.service.hideSpinner();  
    }
    
  }

  returnToDashboard(): void {
    this.route.navigate(['principal/dashboard']);
  }

}
